// auto-generated by Typewriter template _models.tst from PortCall.Wartsila.EndPoints\Api\EnhancedEstimateQuery\ApiEnhancedEstimateQuery.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AutomationSystem, AutomationSystemData, AutomationSystemOptions } from 'data/models/AutomationSystem';
import { EnhancedEstimate, EnhancedEstimateData, EnhancedEstimateOptions } from 'data/models/EnhancedEstimate';
import { Location, LocationData, LocationOptions } from 'data/models/Location';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { EnhancedEstimateQueryStatus, UnactionableReason } from 'server/enums/EnhancedEstimateQuery';

// EnhancedEstimateQueryData is the class that EnhancedEstimateQuery serializes to/from
export interface EnhancedEstimateQueryData {
    Id : number;
	
    Automation : AutomationSystemData | null;
    AutomationId : number;
    Destination : LocationData | null;
    DestinationId : number | null;
    PortCallSelf : PortCallSelfData | null;
    PortCallSelfId : number;
    Result : EnhancedEstimateData | null;
    Vessel : VesselData | null;
    VesselId : number | null;
	
    CreationDate : /* ISO8601 */ string;
    DestinationZoneCoordinates : string | null;
    DestinationZoneType : string | null;
    FailureDetails : string | null;
    IMO : number | null;
    IMORaw : string | null;
    Status : EnhancedEstimateQueryStatus;
    UnactionableReason : UnactionableReason;
}

// EnhancedEstimateQueryOptions is the class which may be passed to the EnhancedEstimateQuery constructor to define optional initial data values
export interface EnhancedEstimateQueryOptions {
    Id : number;
	
    Automation? : AutomationSystemOptions | null;
    AutomationId? : number;
    Destination? : LocationOptions | null;
    DestinationId? : number | null;
    PortCallSelf? : PortCallSelfOptions | null;
    PortCallSelfId? : number;
    Result? : EnhancedEstimateOptions | null;
    Vessel? : VesselOptions | null;
    VesselId? : number | null;
	
    CreationDate? : /* ISO8601 */ string;
    DestinationZoneCoordinates? : string | null;
    DestinationZoneType? : string | null;
    FailureDetails? : string | null;
    IMO? : number | null;
    IMORaw? : string | null;
    Status? : EnhancedEstimateQueryStatus;
    UnactionableReason? : UnactionableReason;
}

export class EnhancedEstimateQuery {
    public Id : DataSignal<number>;
	
    public Automation : DataSignal<AutomationSystem | null>;
    public AutomationId : DataSignal<number>;
    public Destination : DataSignal<Location | null>;
    public DestinationId : DataSignal<number | null>;
    public PortCallSelf : DataSignal<PortCallSelf | null>;
    public PortCallSelfId : DataSignal<number>;
    public Result : DataSignal<EnhancedEstimate | null>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number | null>;
	
    public CreationDate : DataSignal<TZDate>;
    public DestinationZoneCoordinates : DataSignal<string | null>;
    public DestinationZoneType : DataSignal<string | null>;
    public FailureDetails : DataSignal<string | null>;
    public IMO : DataSignal<number | null>;
    public IMORaw : DataSignal<string | null>;
    public Status : DataSignal<EnhancedEstimateQueryStatus>;
    public UnactionableReason : DataSignal<UnactionableReason>;

    constructor();
    constructor(data : EnhancedEstimateQueryOptions);
    constructor(data: EnhancedEstimateQueryOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Automation = S.value<AutomationSystem | null>(null);
        this.AutomationId = jsonableObservable(S.value<number>(data && data.AutomationId !== undefined ? data.AutomationId : 0));
        this.Destination = S.value<Location | null>(null);
        this.DestinationId = jsonableObservable(S.value<number | null>(data && data.DestinationId !== undefined ? data.DestinationId : null));
        this.PortCallSelf = S.value<PortCallSelf | null>(null);
        this.PortCallSelfId = jsonableObservable(S.value<number>(data && data.PortCallSelfId !== undefined ? data.PortCallSelfId : 0));
        this.Result = S.value<EnhancedEstimate | null>(null);
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number | null>(data && data.VesselId !== undefined ? data.VesselId : null));
	    
        this.CreationDate = jsonableObservable(S.value<TZDate>(data && data.CreationDate !== undefined ? new TZDate(data.CreationDate) : new TZDate(0), TZDate.eq));
        this.DestinationZoneCoordinates = jsonableObservable(S.value<string | null>(data && data.DestinationZoneCoordinates !== undefined ? data.DestinationZoneCoordinates : null));
        this.DestinationZoneType = jsonableObservable(S.value<string | null>(data && data.DestinationZoneType !== undefined ? data.DestinationZoneType : null));
        this.FailureDetails = jsonableObservable(S.value<string | null>(data && data.FailureDetails !== undefined ? data.FailureDetails : null));
        this.IMO = jsonableObservable(S.value<number | null>(data && data.IMO !== undefined ? data.IMO : null));
        this.IMORaw = jsonableObservable(S.value<string | null>(data && data.IMORaw !== undefined ? data.IMORaw : null));
        this.Status = jsonableObservable(S.value<EnhancedEstimateQueryStatus>(data && data.Status !== undefined ? data.Status : 0));
        this.UnactionableReason = jsonableObservable(S.value<UnactionableReason>(data && data.UnactionableReason !== undefined ? data.UnactionableReason : 0));
    }

    static key(obj : EnhancedEstimateQuery) {
        return obj.Id();
    }
    
    static dataKey(obj : EnhancedEstimateQueryOptions) {
        return obj.Id;
    }

    static update(obj : EnhancedEstimateQuery, data : EnhancedEstimateQueryOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.AutomationId !== undefined) obj.AutomationId(data.AutomationId);
            if (data.DestinationId !== undefined) obj.DestinationId(data.DestinationId);
            if (data.PortCallSelfId !== undefined) obj.PortCallSelfId(data.PortCallSelfId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.CreationDate !== undefined) obj.CreationDate(new TZDate(data.CreationDate));
            if (data.DestinationZoneCoordinates !== undefined) obj.DestinationZoneCoordinates(data.DestinationZoneCoordinates);
            if (data.DestinationZoneType !== undefined) obj.DestinationZoneType(data.DestinationZoneType);
            if (data.FailureDetails !== undefined) obj.FailureDetails(data.FailureDetails);
            if (data.IMO !== undefined) obj.IMO(data.IMO);
            if (data.IMORaw !== undefined) obj.IMORaw(data.IMORaw);
            if (data.Status !== undefined) obj.Status(data.Status);
            if (data.UnactionableReason !== undefined) obj.UnactionableReason(data.UnactionableReason);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/EnhancedEstimateQuery.ts